/* global TimeoutId */
import {
  getWindowOrThrow,
  isPageHidden as isPageHiddenImpl,
} from 'app/utils/env';

/**
 * Creates an event handler that will trigger a callback if the user is idle.
 * @param waitTime The amount of time the user must be idle before callback is triggered.
 * @returns An unsubscribe method.
 */
export const idleCallHandler = (
  waitTime: number,
  callback: () => void,
  environment: {
    isPageHidden: () => boolean;
  } = {
    isPageHidden: isPageHiddenImpl,
  },
) => {
  let timeoutId: TimeoutId | undefined = undefined;

  const visibilityChangeHandler = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    if (environment.isPageHidden()) {
      timeoutId = setTimeout(() => {
        callback();
      }, waitTime);
    }
  };
  // Set the disconnect timeout in the case that condition for disconnect is met after  the page has
  // already become hidden. In which case the visibilitychange event would have beeen fired already.
  getWindowOrThrow().addEventListener('visibilitychange', visibilityChangeHandler);
  visibilityChangeHandler();

  return () => {
    getWindowOrThrow().removeEventListener('visibilitychange', visibilityChangeHandler);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };
};
